module.exports = new __parcel__URL__("vibe-1-mobile.db315073.json").toString();